import React from "react";
import RenderOrientations, {
    RenderOrientation,
} from "../../types/enums/RenderOrientation";

import InputFormOption from "../../types/system/InputFormOption";

import "./RadioList.scss";

interface RadioListProps<T> {
    id?: string;
    value?: T;
    options?: InputFormOption[];
    disabled?: boolean;
    className?: string;
    tooltip?: string | null;
    tooltipPlace?: string;
    display?: RenderOrientation;
    onChange?: (value: T) => void;
}

class RadioList<T> extends React.Component<RadioListProps<T>> {
    render(): React.ReactNode {
        let classNames = "";

        if (this.props.display === RenderOrientations.Vertical)
            classNames += " vertical";

        return (
            <span className={`radio-list${classNames}`}>
                {this.props.options?.map((option, index) => (
                    <label
                        key={index}
                        className={`radio`}
                        data-html={true}
                        data-tip={this.props.tooltip}
                        data-place={this.props.tooltipPlace}>
                        <input
                            id={this.props.id}
                            type="radio"
                            tabIndex={0}
                            checked={this.props.value === option.value}
                            disabled={this.props.disabled === true}
                            onChange={() =>
                                this.props.onChange &&
                                this.props.onChange(option.value)
                            }
                        />
                        <span className="checkmark" />
                        <span className="text">{option.text}</span>
                    </label>
                ))}
            </span>
        );
    }
}

export default RadioList;
